import { render } from "./SubsidiesIndex.vue?vue&type=template&id=4b649c06&scoped=true"
import script from "./SubsidiesIndex.vue?vue&type=script&lang=js"
export * from "./SubsidiesIndex.vue?vue&type=script&lang=js"

import "./SubsidiesIndex.vue?vue&type=style&index=0&id=4b649c06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b649c06"]])

export default __exports__